import React, { useEffect } from "react";
import { useFormik } from "formik";
import { Row, Col, Form, Button } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import TelaAtividadeAIEspecial from "./TelaAtividadeAIEspecial";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import useExcluirAtividadePadrao from "../hooks/useExcluirAtividadePadrao";
import useAssinarAtividadePadrao from "../hooks/useAssinarAtividadePadrao";

const validationSchema = Yup.object().shape({
  textoDocumento: Yup.string()
    .default("")
    .test("textodoc-valido", "Digite o texto do documento", (value, atividade) => {
      if (atividade.parent.siglaAtividade !== "AUINGEIMRC") {
        if (value === "" || value === "<p><br></p>") return false;
      }
      return true;
    }),
  // sequencialAtividade: Yup.string().default(),
  // siglaAtividade: Yup.string().default(""),
  cpfRepresentante: Yup.string()
    .default("")
    .test("cpf-valido", "Digite CPF válido", (value, atividade) => {
      if (
        atividade.parent.siglaAtividade === "AUINCIAIES" ||
        atividade.parent.siglaAtividade === "AUTEREREES" ||
        atividade.parent.siglaAtividade === "AUTEREAIES"
      ) {
        if ((value || []).length !== 14) return false;
      }
      return true;
    }),
  nomeRepresentante: Yup.string()
    .default("")
    .test("nome-valido", "Digite nome do representante", (value, atividade) => {
      if (
        atividade.parent.siglaAtividade === "AUINCIAIES" ||
        atividade.parent.siglaAtividade === "AUTEREREES" ||
        atividade.parent.siglaAtividade === "AUTEREAIES"
      ) {
        if ((value || []).length === 0) return false;
      }

      return true;
    }),
  cargoRepresentante: Yup.string()
    .default("")
    .test("cargo-valido", "Digite cargo do representante", (value, atividade) => {
      if (
        atividade.parent.siglaAtividade === "AUINCIAIES" ||
        atividade.parent.siglaAtividade === "AUTEREREES" ||
        atividade.parent.siglaAtividade === "AUTEREAIES"
      ) {
        if ((value || []).length === 0 || value === undefined || value === null) return false;
      }
      return true;
    }),
  dataCiencia: Yup.date().test(
    "data-valida",
    "Data cadastrada não pode ser nula ou posterior a atual.",
    (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUINCIAIES") {
        if ((value || []).length === 0) return false;

        const hoje = new Date();

        if (Date.parse(value) > hoje) return false;
      }
      return true;
    },
  ),
  txPreliminares: Yup.string()
    .default("")
    .test("texto1-valido", "Digite as informações preliminares", (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUINGEIMRC") {
        if (value === "" || value === "<p><br></p>") return false;
      }
      return true;
    }),
  txProcedimentos: Yup.string()
    .default("")
    .test("texto2-valido", "Digite os procedimentos", (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUINGEIMRC") {
        if (value === "" || value === "<p><br></p>") return false;
      }
      return true;
    }),
  txConstatacoes: Yup.string()
    .default("")
    .test("texto3-valido", "Digite as constatações", (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUINGEIMRC") {
        if (value === "" || value === "<p><br></p>") return false;
      }
      return true;
    }),
  txOcorrencias: Yup.string()
    .default("")
    .test("texto4-valido", "Digite as ocorrências", (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUINGEIMRC") {
        if (value === "" || value === "<p><br></p>") return false;
      }
      return true;
    }),
  txResultado: Yup.string()
    .default("")
    .test("texto5-valido", "Digite o resultado da ação", (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUINGEIMRC") {
        if (value === "" || value === "<p><br></p>") return false;
      }
      return true;
    }),
  cpfTestemunha: Yup.string()
    .default("")
    .test("cpf-test-valido", "Digite CPF válido", (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUTEREREES") {
        if ((value || []).length !== 14) return false;
      }
      return true;
    }),
  nomeTestemunha: Yup.string()
    .default("")
    .test("nome-test-valido", "Digite nome do representante", (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUTEREREES") {
        if ((value || []).length === 0) return false;
      }

      return true;
    }),
  dataRecusa: Yup.date().test(
    "data-valida",
    "Data cadastrada não pode ser nula ou posterior a atual.",
    (value, atividade) => {
      if (atividade.parent.siglaAtividade === "AUTEREREES") {
        if ((value || []).length === 0) return false;

        const hoje = new Date();

        if (Date.parse(value) > hoje) return false;
      }
      return true;
    },
  ),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const TelaProximaAtividadeAIEspecial = ({ dadosOs, data, atividade }) => {
  const { request: salvarRequest, data: salvarData, errors: salvarErrors, isLoading: salvarIsLoading } = useApiClient();

  // Se situacaoUltimoAndamento é 'A' significa que a atividade está em andamento,
  // portanto, o sequencialAndamento a ser usado é o que vem no result.
  // Caso a situação seja G, significa que nova atividade será feita, então
  // o sequencialAndamento ainda será incluído, portanto será enviado valor 0.
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const parametros = {
        sequencialAcaoFiscal: dadosOs.acaoFiscal,
        sequencialProdutoAcaoFiscal: data.sequencialAuto,
        sequencialAtividade: atividade?.sequencialAtividade,
        sequencialAndamento: data?.situacaoUltimoAndamento === "A" ? data?.sequencialUltimoAndamento : 0,
        textoDocumento: values.textoDocumento,
        cpfRepresentante: values?.cpfRepresentante,
        nomeRepresentante: values?.nomeRepresentante,
        cargoRepresentante: values?.cargoRepresentante,
        dataCiencia: values?.dataCiencia,
        txPreliminares: values?.txPreliminares,
        txProcedimentos: values?.txProcedimentos,
        txConstatacoes: values?.txConstatacoes,
        txOcorrencias: values?.txOcorrencias,
        txResultado: values?.txResultado,
        nomeTestemunha: values?.nomeTestemunha,
        cpfTestemunha: values?.cpfTestemunha,
        dataRecusa: values?.dataRecusa,
      };

      if (data.situacaoUltimoAndamento === "A") {
        salvarRequest(apiRoutes.fiscalizacao.autoinfracao.alterarAtividadePadrao, parametros);
      } else {
        salvarRequest(apiRoutes.fiscalizacao.autoinfracao.incluirAtividadePadrao, parametros);
      }
    },
  });

  const { excluirAtividade, excluirErrors, excluirIsLoading } = useExcluirAtividadePadrao({ data });

  const { assinarAtividade, assinarIsLoading, assinarErrors } = useAssinarAtividadePadrao({
    data,
    atividade,
    formik,
  });

  const { setSubmitting } = formik;

  useEffect(() => {
    if (salvarIsLoading) return;

    if (!salvarData && !salvarErrors) return;

    if (salvarData) {
      toast.success("Atividade salva com sucesso!");
      window.location.reload();
    }
    setSubmitting(false);
  }, [salvarData, salvarErrors, salvarIsLoading, setSubmitting]);

  const { setValues } = formik;

  useEffect(() => {
    let texto = data.situacaoUltimoAndamento === "A" ? data.txDocumentoUltimoAndamento : atividade?.textoDocumento;
    const sequencialAtividade = atividade?.sequencialAtividade;
    const siglaAtividade = atividade?.siglaAtividade ? atividade?.siglaAtividade : "";
    const cpfRepresentante = data.cpfRepresentante ? data.cpfRepresentante : "";
    const nomeRepresentante = data.nomeRepresentante ? data.nomeRepresentante : "";
    const cargoRepresentante = data.cargoRepresentante ? data.cargoRepresentante : "";
    const dataCiencia = data.dataCiencia ? data.dataCiencia : "";
    const txPreliminares = data.txPreliminares ? data.txPreliminares : "";
    const txProcedimentos = data.txProcedimentos ? data.txProcedimentos : "";
    const txConstatacoes = data.txConstatacoes ? data.txConstatacoes : "";
    const txOcorrencias = data.txOcorrencias ? data.txOcorrencias : "";
    const txResultado = data.txResultado ? data.txResultado : "";
    const sequencialUltimoAndamento = data.situacaoUltimoAndamento === "A" ? data.sequencialUltimoAndamento : 0;
    const cpfTestemunha = data.cpfTestemunha ? data.cpfTestemunha : "";
    const nomeTestemunha = data.nomeRepresentante ? data.nomeTestemunha : "";
    const dataRecusa = data.dataRecusa ? data.dataRecusa : "";

    if (texto === null) {
      texto = "";
    }

    setValues((curr) => ({
      ...curr,
      textoDocumento: texto,
      sequencialAtividade,
      sequencialUltimoAndamento,
      siglaAtividade,
      cpfRepresentante,
      nomeRepresentante,
      cargoRepresentante,
      dataCiencia,
      txPreliminares,
      txProcedimentos,
      txConstatacoes,
      txOcorrencias,
      txResultado,
      cpfTestemunha,
      nomeTestemunha,
      dataRecusa,
    }));
  }, [
    setValues,
    atividade?.textoDocumento,
    data.situacaoUltimoAndamento,
    data.txDocumentoUltimoAndamento,
    atividade?.sequencialAtividade,
    atividade?.siglaAtividade,
    data.cpfRepresentante,
    data.nomeRepresentante,
    data.cargoRepresentante,
    data.dataCiencia,
    data.txPreliminares,
    data.txProcedimentos,
    data.txConstatacoes,
    data.txOcorrencias,
    data.txResultado,
    data.sequencialUltimoAndamento,
    data.nomeTestemunha,
    data.cpfTestemunha,
    data.dataRecusa,
  ]);

  if (!atividade?.sequencialAtividade) {
    return null;
  }

  return (
    <>
      <FormAlert
        formik={formik}
        data={salvarData}
        errors={salvarErrors || excluirErrors || assinarErrors}
        isLoading={salvarIsLoading || excluirIsLoading || assinarIsLoading}
        dismissible
      />
      <Form noValidate onSubmit={formik.handleSubmit}>
        <Row className="mt-2">
          <Col>
            <Row className="text-right">
              <Col>
                <Button variant="primary" className="mr-3" size="sm" onClick={formik.handleSubmit}>
                  Salvar
                </Button>
                <Button
                  variant="primary"
                  className="mr-3"
                  size="sm"
                  disabled={!formik.isValid}
                  onClick={() => {
                    assinarAtividade();
                  }}
                >
                  Assinar
                </Button>
                {data.situacaoUltimoAndamento === "A" && (
                  <Button variant="primary" className="mr-3" size="sm" onClick={() => excluirAtividade()}>
                    Excluir
                  </Button>
                )}
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <h5>{atividade.nomeAtividade}</h5>
              </Col>
            </Row>

            <TelaAtividadeAIEspecial formik={formik} dadosOs={dadosOs} atividade={atividade} />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default TelaProximaAtividadeAIEspecial;
